import { LocalizationService } from '../types/localization-service';
import { localization } from '@duda-co/host-services';

export const localizationService: LocalizationService = {
    str: (key, replacements) => {
        return localization.str(key, replacements);
    },
    getAllStringsForCurrentLang: () => {
        throw new Error('not implemented');
    },
};
